import * as S from './styles'

export default function PrivacyPolice() {
  return <S.Container></S.Container>
}
